import * as I18n from "./translations/I18n";
export var checkDomain = function (check) {
    var checked = false;
    check.forEach(function (c) {
        var _a;
        if (((_a = process.env.REACT_APP_URL) === null || _a === void 0 ? void 0 : _a.includes(c)) || window.location.host.includes(c)) {
            checked = true;
        }
    });
    return checked;
};
export var getCurrentEnv = function () {
    if (checkDomain(["int.", "test."])) {
        return "int";
    }
    else if (checkDomain(["cons.", "acc."])) {
        return "cons";
    }
    else if (checkDomain(["dev."])) {
        return "dev";
    }
    else if (checkDomain(["localhost"])) {
        return "local";
    }
    /* istanbul ignore next */
    return "prod";
};
export var getCurrentEnvLabel = function () {
    var gCE = getCurrentEnv();
    switch (gCE) {
        /* istanbul ignore next */
        case "int": {
            return I18n.getText("mary.utils.whichenv.int", "Integration");
        }
        case "cons": {
            return I18n.getText("mary.utils.whichenv.cons", "Consolidation");
        }
        /* istanbul ignore next */
        case "dev": {
            return I18n.getText("mary.utils.whichenv.dev", "Development");
        }
        /* istanbul ignore next */
        case "prod": {
            return I18n.getText("mary.utils.whichenv.prod", "Production");
        }
        /* istanbul ignore next */
        case "local": {
            return I18n.getText("mary.utils.whichenv.local", "Local");
        }
        /* istanbul ignore next */
        default: {
            return "";
        }
    }
};
